import { type GuidanceItemKey, type GuidanceSnapshot } from "../guidanceModel";
import { makeGuidanceSnapshot } from "../makeGuidanceSnapshot";
import { type GuidanceDialogView } from "./GuidanceDialog";

export type GuidancePreview =
    | { surface: "dialog"; view: GuidanceDialogView; snapshot: GuidanceSnapshot; expandedKey?: GuidanceItemKey }
    | { surface: "banner"; snapshot: GuidanceSnapshot };

/** Dev-only `?gpuGuidancePreview=intro|steps|stepsExpanded|confirmIgnore|banner` so the wizard can be screenshot without a misconfigured GPU. */
export function getGuidancePreview(): GuidancePreview | null {
    if (!import.meta.env.DEV || typeof window === "undefined") {
        return null;
    }

    const value = new URLSearchParams(window.location.search).get("gpuGuidancePreview");
    if (!value) {
        return null;
    }

    const snapshot = makeGuidanceSnapshot();
    if (value === "intro") {
        return { surface: "dialog", view: "intro", snapshot };
    }
    if (value === "steps") {
        return { surface: "dialog", view: "steps", snapshot };
    }
    if (value === "stepsExpanded") {
        return { surface: "dialog", view: "steps", snapshot, expandedKey: "tabsAndPower" };
    }
    if (value === "confirmIgnore") {
        return { surface: "dialog", view: "confirmIgnore", snapshot };
    }
    if (value === "banner") {
        return { surface: "banner", snapshot };
    }
    return null;
}
